import { Link } from 'react-router-dom';
import { categories } from '@/mocks/data';

export default function Footer() {
  return (
    <footer className="bg-foreground-900 text-background-200">
      <div className="px-4 md:px-6 py-14">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
            <div>
              <h3 className="font-heading text-lg font-semibold text-background-50 mb-4">
                年轻的朋友韩国
              </h3>
              <p className="text-sm text-foreground-400 leading-relaxed">
                专为年轻人打造的韩国旅行指南平台。从首尔街头到济州海岛，我们陪你探索韩国的每一个精彩角落。
              </p>
            </div>

            <div>
              <h4 className="font-heading text-sm font-semibold text-background-100 mb-4">
                <a href="#explore-categories" className="hover:text-primary-400 transition-colors">探索板块</a>
              </h4>
              <ul className="space-y-2.5">
                {categories.map((cat) => (
                  <li key={cat.id}>
                    <Link
                      to={`/category/${cat.slug}`}
                      className="text-sm text-foreground-400 hover:text-primary-400 transition-colors whitespace-nowrap cursor-pointer"
                    >
                      {cat.name}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>

            <div>
              <h4 className="font-heading text-sm font-semibold text-background-100 mb-4">
                <a href="#quick-links" className="hover:text-primary-400 transition-colors">快速链接</a>
              </h4>
              <ul className="space-y-2.5">
                <li>
                  <Link to="/" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors whitespace-nowrap cursor-pointer">
                    首页
                  </Link>
                </li>
                <li>
                  <Link to="/about" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors whitespace-nowrap cursor-pointer">
                    关于我们
                  </Link>
                </li>
                <li>
                  <a href="#contact" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors whitespace-nowrap cursor-pointer">
                    联系我们
                  </a>
                </li>
              </ul>
            </div>

            <div>
              <h4 className="font-heading text-sm font-semibold text-background-100 mb-4" id="contact">
                联系我们
              </h4>
              <ul className="space-y-2.5">
                <li className="flex items-center gap-2 text-sm text-foreground-400">
                  <i className="ri-mail-line text-base"></i>
                  <span>hello@youngfriendkorea.com</span>
                </li>
                <li className="flex items-center gap-2 text-sm text-foreground-400">
                  <i className="ri-wechat-line text-base"></i>
                  <span>youngfriendkorea</span>
                </li>
                <li className="flex items-center gap-2 text-sm text-foreground-400">
                  <i className="ri-weibo-line text-base"></i>
                  <span>@年轻的朋友韩国</span>
                </li>
              </ul>
              <div className="flex gap-3 mt-4">
                <a href="https://ktojourney.github.io/youngfriendkorea" target="_blank" rel="nofollow noopener" className="w-9 h-9 flex items-center justify-center rounded-full bg-foreground-800 text-foreground-400 hover:bg-primary-500 hover:text-background-50 transition-colors cursor-pointer" aria-label="微博">
                  <i className="ri-weibo-line"></i>
                </a>
                <a href="https://ktojourney.github.io/user/youngfriendkorea" target="_blank" rel="nofollow noopener" className="w-9 h-9 flex items-center justify-center rounded-full bg-foreground-800 text-foreground-400 hover:bg-primary-500 hover:text-background-50 transition-colors cursor-pointer" aria-label="小红书">
                  <i className="ri-chat-smile-2-line"></i>
                </a>
              </div>
            </div>
          </div>

          <div className="mt-12 pt-8 border-t border-foreground-800/50 flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-xs text-foreground-500">
              &copy; 2024 年轻的朋友韩国. All rights reserved.
            </p>
            <div className="flex items-center gap-6">
              <a href="#privacy" className="text-xs text-foreground-500 hover:text-primary-400 transition-colors whitespace-nowrap cursor-pointer">
                隐私政策
              </a>
              <a href="#terms" className="text-xs text-foreground-500 hover:text-primary-400 transition-colors whitespace-nowrap cursor-pointer">
                服务条款
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}